// Keep the active cell outside the popup, even when the list must scroll.
function pickerPosition(cell, panel, viewport) {
    const margin = 8, gap = 6;
    const width = Math.min(panel.width, Math.max(0, viewport.width - margin * 2));
    const below = Math.max(0, viewport.height - margin - cell.bottom - gap);
    const above = Math.max(0, cell.top - margin - gap);
    const down = below >= panel.height || below >= above;
    const height = Math.min(panel.height, down ? below : above);
    const left = Math.max(margin, Math.min(viewport.width - width - margin, cell.left));
    const top = down ? cell.bottom + gap : cell.top - gap - height;
    return {left: `${left}px`, top: `${top}px`, maxHeight: `${height}px`,
        visibility: height >= 24 ? 'visible' : 'hidden'};
}

module.exports = {pickerPosition};
